import angular from 'angular';
import { routerApp } from '../app.module';
import { getCacheBustedTemplate } from '../app.route';

routerApp.directive('carryoverButton', ['$window', function($window) {
    return {
        templateUrl: getCacheBustedTemplate('pages/directives/carryover-button.html'),
        scope: {
            currentValue: '=',
            section: '@',
            field: '@',
            fieldLabel: '@',
            carryOverReport: '=',
            isReadOnly: '=?',
            onHydrate: '&',
            iconClass: '@?',
            buttonStyle: '@?',
            tooltipPlacement: '@?',
        },
        link: function(scope) {
            scope.iconClass = scope.iconClass || 'fa fa-history fa-lg';
            scope.tooltipPlacement = scope.tooltipPlacement || 'left';
            scope.popoverTemplateUrl = getCacheBustedTemplate('pages/directives/carryover-popover.html');
            scope.isPopoverOpen = false;

            let ignoreCarryOver = false;

            const closePopoverOnResize = function() {
                if (!scope.isPopoverOpen) return;
                scope.$apply(function() {
                    scope.isPopoverOpen = false;
                });
            };

            angular.element($window).on('resize', closePopoverOnResize);
            scope.$on('$destroy', function() {
                angular.element($window).off('resize', closePopoverOnResize);
            });

            scope.getPreviousValue = function() {
                return scope.carryOverReport?.[scope.section]?.[scope.field];
            };

            scope.isDataAvailable = function() {
                return scope.getPreviousValue() != null;
            };

            scope.getTooltipText = function() {
                if (!scope.isDataAvailable()) return 'No previous data available';
                if (!scope.hasDifference()) return 'Current value matches previous';
                return 'Update with previous report value';
            };

            scope.isDisabled = function() {
                return !scope.isDataAvailable() || !scope.hasDifference();
            };

            scope.isCurrentValueEmpty = function() {
                return scope.currentValue == null || scope.currentValue === '';
            };

            scope.hasDifference = function() {
                if (!scope.isDataAvailable()) return false;
                if (scope.isCurrentValueEmpty()) return true;
                return scope.getPreviousValue() != scope.currentValue;
            };

            scope.showBadge = function() {
                return !ignoreCarryOver && scope.hasDifference();
            };

            scope.needsConfirmation = function() {
                return !scope.isDisabled() && !scope.isCurrentValueEmpty();
            };

            scope.onButtonClick = function() {
                if (scope.isCurrentValueEmpty()) scope.updateConfirmed();
            };

            scope.updateConfirmed = function() {
                scope.isPopoverOpen = false;
                if (scope.isDisabled()) return;
                scope.onHydrate({
                    sectionName: scope.section,
                    fieldName: scope.field,
                    carryOverReport: scope.carryOverReport,
                });
            };

            scope.ignore = function() {
                ignoreCarryOver = true;
                scope.isPopoverOpen = false;
            };
        },
    };
}]);
